import { render, staticRenderFns } from "./DonutChart02.vue?vue&type=template&id=4f423232&scoped=true"
import script from "./DonutChart02.vue?vue&type=script&lang=js"
export * from "./DonutChart02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f423232",
  null
  
)

export default component.exports